import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import {
  Button,
  Responsive
} from 'react-admin'
import MuiButton from '@material-ui/core/Button'

import Add from '@material-ui/icons/PersonAdd'
import { withStyles } from '@material-ui/core/styles'
import classnames from 'classnames'
import { translate } from 'ra-core'
import onlyUpdateForKeys from 'recompose/onlyUpdateForKeys'
import compose from 'recompose/compose'

import { toggleRegisterUserModal } from '../../../redux/actions/modals'
import RegisterUserModal from '../modals/RegisterUserModal'

const styles = theme => ({
  floating: {
    color: theme.palette.getContrastText(theme.palette.primary.main),
    margin: 0,
    top: 'auto',
    right: 20,
    bottom: 60,
    left: 'auto',
    position: 'fixed',
    zIndex: 1000
  },
  floatingLink: {
    color: 'inherit'
  }
})

const RegisterUserAction = props => (
  <Fragment>
    <Responsive
      small={
        <MuiButton
          variant='fab'
          color='primary'
          className={classnames(props.classes.floating, props.className)}
        >
          <Add />
        </MuiButton>
      }
      medium={
        <Button
          label='Register user'
          color='primary'
          onClick={props.toggleRegisterUserModal}
        >
          <Add />
        </Button>
      }
    />
    <RegisterUserModal record={props.record} />
  </Fragment>
)

const enhance = compose(
  translate,
  onlyUpdateForKeys(['basePath', 'label']),
  withStyles(styles)
)

export default enhance(connect(null, {
  toggleRegisterUserModal
})(RegisterUserAction))
